export const columns: any[] = [
	{
		title: '序号',
		dataIndex: 'order',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '录单日期',
		align: 'center',
		dataIndex: 'createTime',
		scopedSlots: { customRender: 'createTime' },
	},
	{
		title: '订单号',
		align: 'center',
		dataIndex: 'orderNo',
	},
	{
		title: '订单状态',
		align: 'center',
		dataIndex: 'orderStatus',
		scopedSlots: { customRender: 'orderStatus' },
	},
	{
		title: '评价得分',
		align: 'center',
		dataIndex: 'evInsuranceScore',
	},
	{
		title: '评价详情',
		align: 'center',
		dataIndex: 'evInsuranceComment',
	},
	{
		title: '操作',
		align: 'center',
		dataIndex: 'action',
		scopedSlots: { customRender: 'action' },
	},
]
